import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useCreateStage } from "../../entities/api";
import generateUUIdv4 from "../../utilities/generateUUIdv4";
import AddAndEditStageModal from "./AddAndEditStageModal";

const AddNewStage = () => {
  const { formatMessage } = useIntl();
  const [openModal, setOpenModal] = useState(false);
  const { mutate: createFn, isPending: isCreatePending, isSuccess } = useCreateStage();

  const handleCloseModal = () => setOpenModal((prev) => !prev);

  useEffect(() => {
    if (isSuccess) {
      handleCloseModal();
    }
  }, [isSuccess]);
  const handleSendRequest = async (form) => {
    try {
      const data = await form.validateFields();
      createFn({
        ...data,
        stageCode: generateUUIdv4(),
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Button
        onClick={handleCloseModal}
        icon={<i className="fas fa-plus" style={{ marginRight: "5px" }} />}
        type={"primary"}
      >
        {formatMessage({
          id: "stages.add",
          defaultMessage: "Add new stage",
        })}
      </Button>
      <AddAndEditStageModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        handleSendRequest={handleSendRequest}
        okButtonLoading={isCreatePending}
      />
    </>
  );
};

export default AddNewStage;
